import { createStore } from "vuex";
import createStoreOptions from "./createStoreOptions";
import vuexPersist from "./vuexPersist";
import initClearStoreOnEvents from "./clearStoreOnEvents";

const storeContext = require.context("./modules", true, /.*\.js$/);
const { storeOptions } = createStoreOptions(storeContext);

storeOptions.strict = process.env.NODE_ENV === "development";

const store = createStore(storeOptions);
vuexPersist(store);
initClearStoreOnEvents();

export function registerDynamicModules(dynamicModulesContext) {
  const dynamicModules = createStoreOptions(dynamicModulesContext).storeOptions
    ?.modules;

  if (!dynamicModules) return;

  Object.keys(dynamicModules).forEach((moduleName) =>
    store.registerModule(moduleName, dynamicModules[moduleName])
  );
}

export default store;
